export class Search {

  public constructor() {
    $('[data-search]').on('keyup', (e) => {
      this.find($('input[data-search]').val() as string);
    })
  }

  private find(value: string) {
    $("[data-game]").each((i, el) => {
      const searchAttrValue = String($(el).data('name'));
      if (value == "") {
        this.show($(el));
      } else {
        if (searchAttrValue.toLowerCase().indexOf(value.toLowerCase()) < 0) {
          this.hide($(el));
        } else {
          this.show($(el));
        }
      }
    });

    this.hideSections(value);
    $('[data-search-empty]').toggle(!!value && $('[data-game]').not('[data-hidden]').length === 0);
  }

  private hideSections(value: string) {
    $('.gameserver-group, .gamecloud-layout .gamecloud').each((index, el) => {
      $(el).toggle(!value || $(el).find('[data-game]').not('[data-hidden]').length > 0);
    });
  }

  private show(el: JQuery) {
    el.show().removeAttr('data-hidden');
  }

  private hide(el: JQuery) {
    el.hide().attr('data-hidden', '1');
  }
}
